import { createContext } from 'react'

export const scrollContext = createContext<React.RefObject<HTMLElement> | null>(
  null
)
